/*
 * @Description:
 * @Author: 山淑兰
 * @Date: 2020-01-17 18:56:37
 * @LastEditTime : 2020-03-12 16:36:00
 * @LastEditors  : 山淑兰
 */
/**
 * 报名用户数据接口
 */
export class IInitSignUpSetUserConfig {
  m: string = "";
}
/**
 * 获取报名用户信息接口
 */
export class IGetSignMeetingUser {
  m: string = "";
  muid: number = -1;
}
/**
 * 修改报名信息接口
 */
export class IEditSignMeetingUser {
  m: string = "";
  muid: number = -1;
  UserEntity: any[] = [];
}
/**
 * 修改支付凭证接口
 */
export class IEditUserVouch {
  m: string = "";
  muid: number = -1;
  vouchimg: string = "";
}
/**
 * 获取当前登录账户开票信息接口
 */

export class IInitSignUpInvoice {
  m: string = "";
  muid: number = 0;
}
/**
 * 编辑发票信息
 */
export class IEditUserInvoice {
  m: string = "";
  invid: number = 0;
  muid: number = 0;
  username: string = "";
  userphone: string = "";
  invtype: number = 0;
  invtitle: string = "";
  invconder: string = "";
  invaddress: string = "";
  invphone: string = "";
  invbank: string = "";
  invbanknum: string = "";
  invmoney: string = "";
  mailingaddress: string = "";
  invdatetime?: any;
  invprove?: string;
}

/**
 * 获取验证码
 */
export class IVerSendMsg {
  m: string = "";
  phone: number = -1;
}

/**
 * 检查验证码
 */
export class ICheckModfiyUser {
  code: number = -1;
  phone: number = -1;
}
/**
 * 修改手机号
 */
export class IModfiyPhone {
  code: number = -1;
  modfiyphone: number = -1;
}

